import {ROOT_URL} from '../../config';
import request from '../../components/api/api';
import {push} from 'react-router-redux';
import {toastr} from 'react-redux-toastr';
import swal from 'sweetalert';
import {fetchedUser, updatedUser} from './actions';

export function fetchUser(id) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/users/${id}`,
            method: 'GET'
        };

        return request(options, dispatch).then(response => {
            dispatch(fetchedUser(response.data));
            if (response.data.password_updated_at === null) {
                swal({
                    title: 'Password update required!',
                    text:
                        'This is your first login so you need to update your password!',
                    icon: 'warning',
                    closeOnClickOutside: false,
                    closeOnEsc: false
                });
            }
        });
    };
}

export function updateUser(user) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/myaccount/${user.id}`,
            method: 'PUT',
            data: {
                name: user.name,
                email: user.email,
                current_password: user.current_password,
                new_password: user.new_password,
                new_password_repeat: user.new_password_repeat
            }
        };
        return request(options, dispatch).then(response => {
            dispatch(updatedUser(user));
            if (response.data.updatedPassword) {
                swal({
                    title: 'Success',
                    text: `Password updated! Sign Out and then login with the new password!`,
                    icon: 'success',
                    button: 'Sign Out',
                    closeOnClickOutside: false,
                    closeOnEsc: false
                }).then(() => dispatch(push('/logout')));
            } else {
                toastr.success(
                    'Success!',
                    `User ${user.name} has been updated.`
                );
            }
        });
    };
}



// WEBPACK FOOTER //
// ./src/containers/myaccount/thunks.js